import * as React from 'react';

import DocumentHeader from 'Components/DocumentHeader';
import DocumentWrapper from 'Components/DocumentWrapper';
import FormEditingHandler from 'Containers/FormEditingHandler';
import History from './HistoryRowData';
import Form from './Form';
import { docType } from '../utils';
import type { TImagingDocumentType } from '../utils';

const Imaging = ({ documents }: IOwnProps): React.JSX.Element => (
  <FormEditingHandler name="imaging" documents={documents}>
    {(editing, startEdit, formData, view): React.JSX.Element => {
      const type = docType(documents, editing);
      return (
        <DocumentWrapper>
          <DocumentHeader
            name={'imaging'}
            headerId={type ? `imaging.${type}` : 'imaging.title'}
            editing={editing}
            editButtons={<div />}
          />
          {editing ? <Form formData={formData} document={documents.find(d => d._id === editing)} /> : null}
          {!editing && !view?.viewing ? <History documents={documents} startEdit={startEdit} /> : undefined}
        </DocumentWrapper>
      );
    }}
  </FormEditingHandler>
);

interface IOwnProps {
  documents: Array<IDocumentWithTypeV2<TImagingDocumentType>>;
}

export default Imaging;
